module.exports = __webpack_public_path__ + "img/logo.1ec430f5.jpg";